import React, { useContext, useMemo } from 'react'
import { MarketingLabel } from 'chemistry'
import DiscountPercentage from '../DiscountPercentage'
import gallerySelector from '../../selectors/gallery'
import { isOnlineOnly } from 'common/deliveryMode'
import { getProductName } from 'client/common/selectors/product'
import DeliveryModeLabel from 'client/fragments/productDetailsFragmentInfo/components/DeliveryModeLabel'
import EmblaCarousel from './EmblaCarousel'
import { TranslateContext } from 'client/common/translator'
import { AddToWishlistButton } from './AddToWishlistButton'

export const DetailImage = ({
  productDetails,
  lang,
  format,
  children,
  allowWishlist,
  productId,
  isGuest,
  currentLocation,
  hideVLP,
  marketingLabel
}) => {
  const { images, mediaAssets, deliveryModes, offers, useMaxedaOfferAsWinner } = productDetails
  const t = useContext(TranslateContext)
  const medias = useMemo(() => gallerySelector(mediaAssets || images), [images, mediaAssets])
  const showLabel = isOnlineOnly(deliveryModes, useMaxedaOfferAsWinner, offers)
  const name = getProductName(productDetails)

  const slides = medias.map((item, index) => ({
    type: item.type,
    url: item.src || item.video?.source?.[0]?.src,
    alt: `${name} ${index === 0 ? '' : index + 1}`.trim(),
    bigUrl: item.src?.replace('424x424', '1400x1400') || item?.video?.source,
    smallUrl: item.thumb
  }))

  return (
    <div className='mxd-product-detail-layout-product mxd-product-detail-layout-image'>
      <DiscountPercentage product={productDetails} lang={lang} format={format} hideVLP={hideVLP} />
      {allowWishlist && (
        <AddToWishlistButton
          productDetails={productDetails}
          currentLocation={currentLocation}
          isGuest={isGuest}
          productId={productId}
          format={format}
          lang={lang}
          t={t}
        />
      )}
      <EmblaCarousel slides={slides} options={{}} lang={lang} />
      {showLabel && (
        <div className='mxd-product-detail-layout-product-meta'>
          <DeliveryModeLabel deliveryMode={t('deliveryMode_exclusive')} position={marketingLabel ? 'left' : 'right'} />
        </div>
      )}
      {marketingLabel && (
        <MarketingLabel
          labelText={marketingLabel?.labelText}
          url={marketingLabel?.url}
          metadata={{
            ...(hideVLP ? { textColor: 'yellow.500' } : {}),
            ...(marketingLabel?.metadata || {})
          }}
          sizes={['lg', 'sm']}
          lgImageMaxSize='142px'
          smImageMaxSize='128px'
          sx={{
            position: 'absolute',
            right: 'var(--promotion-label-margin)',
            bottom: 'calc(106px + var(--promotion-label-margin))',
            zIndex: 5
          }}
        />
      )}
      {children}
    </div>
  )
}

export default DetailImage
